export default __webpack_public_path__ + "static/media/a10bce802e9c25dbb63bda051e9c27fa.svg";